export default {
    // special cost
    'BLOCKER': null,
    'STOP': -1,
};